import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({}) => {
  return (
    <footer className="bg-light bottom-0 w-100 p-3">
      <div className="d-flex p-3 gap-3 justify-content-between">
        <div className=''>
          <Link to="/privacy-policy">
            <p className="d-md-inline fw-200 fs-1rem underline text-capitalize">privacy policy</p>
          </Link>
        </div>
        <div className='ml-auto'>
          <p className="d-md-inline fw-light fs-1rem">Created by Paz Roth ©</p>
        </div>
      </div>
    </footer>
  );
}
  
  export default Footer;
  